import { MutationTree } from "vuex";
import { Rapport, RapportFav } from "@/shared/Rapport";
import { RapportState } from "./types";

export const mutations: MutationTree<RapportState> = {
  SET_ALL_REPORTS(state, rapports) {
    localStorage.allReports = JSON.stringify(rapports);
    state.allReports = rapports;
  },
  SET_METRICS(state, metrics) {
    localStorage.metrics = JSON.stringify(metrics);
    state.metrics = metrics;
  },
  UPDATE_RAPPORT(state, rapport: Rapport) {
    state.rapport = rapport;
  },
  UPDATE_SELECTED_FAVORIS(state, rapport: RapportFav) {
    if (rapport) {
      state.selectedFavoris = rapport.id;
    } else {
      state.selectedFavoris = "";
    }
  },
  SET_FAVORIS(state, favoris) {
    state.favoris = favoris;
    localStorage.favoris = JSON.stringify(favoris);
  },
  ADD_FAVORIS(state, favoris) {
    state.favoris.push(favoris);
    // console.log(state.favoris.length);
    localStorage.favoris = JSON.stringify(state.favoris);
  },
  REMOVE_FAVORIS(state, favoris) {
    const index = state.favoris.findIndex((fav) => fav.id === favoris.id);
    state.favoris.splice(index, 1);
    localStorage.favoris = JSON.stringify(state.favoris);
  },
  UPDATE_FAVORIS(state, favToUpdate) {
    if (state.isNewFav) {
      state.favoris.push(favToUpdate);
      state.isNewFav = false;
    } else {
      state.favoris = [
        ...state.favoris.filter((element) => element.id !== favToUpdate.id),
        favToUpdate,
      ];
    }
    localStorage.favoris = JSON.stringify(state.favoris);
  },
  CLEAR(state) {
    state.rapport = new Rapport();
  },
  UPDATE_IS_NEW(state, isNew) {
    state.isNewFav = isNew;
  },
  UPDATE_NEW_FAV(state, fav) {
    state.newFav = fav;
  },
};
